export default {
	"UPDATE": "meta/UPDATE"
};
